// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-unused-expressions, react-hooks/exhaustive-deps, react-hooks/immutability, react-hooks/rules-of-hooks */

import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import _ from "lodash";

import Tooltip from "rc-tooltip";
import { Accordion, Dropdown, Icon, Image, Input, List, Menu } from "semantic-ui-react";

import { useAuth0 } from "../../../auth/auth0";
import { useModuleNavigation } from "../../../hooks/useModuleNavigation";
import { useUserAuth } from "../../../hooks/useUserAuth";

import moment from "moment";
import logo from "../../../assets/aerialFARMS_flat.svg";
import { useUserSettings } from "../../../hooks/useUserSettings";
import ProtocolFavoritingWidget from "../../Content/Widgets/Favorites/ProtocolFavoritingWidget";
import TrialFavoritingWidget from "../../Content/Widgets/Favorites/TrialFavoritingWidget";
import { ApplicationArea } from "../../Lumber/ApplicationAreas";
import "./style.css";

//-- #073763 = rgb(7, 55, 99)

const Header = ({ entityNames, pageTitle }) => {
	const { isAuthenticated } = useAuth0();
	const userAuth = useUserAuth();
	const moduleNavigation = useModuleNavigation();

	const [clients, setClients] = useState(null);
	const clientLogoUri = useSelector((state) => (state.clientLogoUri ? state.clientLogoUri : null));

	const relatedLinks = useMemo(() => {
		if (!entityNames || !entityNames.relatedLinks) return null;
		return entityNames.relatedLinks.reduce(
			(acc, rl) => {
				const curr = {
					name: rl.name,
					dateAndTime: rl.dateAndTime,
					type: rl.type.charAt(0).toUpperCase() + rl.type.slice(1),
				};

				if (rl.type === "flight") {
					curr.linkTo = moduleNavigation.createFlightLink(true, rl.id, "viewer");
					acc.flights.push(curr);
					return acc;
				}

				if (rl.type === "data-layer") {
					curr.linkTo = moduleNavigation.createFlightLink(true, rl.id, "data-layer-upload");
					acc.dataLayers.push(curr);
					return acc;
				}

				if (rl.type === "trial") {
					if (entityNames.fieldScaleTrial) {
						curr.linkTo = moduleNavigation.createTrialLink(true, rl.id, "geo-mfa-explorer");
					} else {
						curr.linkTo = moduleNavigation.createTrialLink(true, rl.id, "viewer");
					}
					acc.trials.push(curr);
					return acc;
				}

				if (rl.type === "protocol") {
					curr.linkTo = moduleNavigation.createProtocolLink(true, rl.id, "overview-status");
				}
				if (rl.type === "field") {
					curr.linkTo = moduleNavigation.createFieldLink(true, rl.id, "viewer");
				}
				if (rl.type === "farm") {
					curr.linkTo = moduleNavigation.createFarmLink(true, rl.id, "viewer");
				}
				acc.others.push(curr);
				return acc;
			},
			{ flights: [], dataLayers: [], trials: [], others: [] },
		);
	}, [entityNames, moduleNavigation.activeModule.name]);

	useEffect(() => {
		if (_.isEmpty(clients)) {
			initializeClientOptions(userAuth.user.userInfo.clientMemberships);
		}
	}, [userAuth.user.userInfo.clientMemberships]);

	function initializeClientOptions(clients) {
		const clientOpts = _.map(clients, (client) => {
			const opt = {
				key: client.clientId,
				value: client.clientId,
				text: client.clientName,
			};
			return opt;
		});

		setClients(clientOpts);

		userAuth.handleClientChange(userAuth.currentClientId, userAuth.currentClientId);
	}

	return (
		<header>
			<Menu borderless size="large" stackable id="rootHeader" className="nav header">
				<Menu.Item
					as={Link}
					to={moduleNavigation.homeModule.paths[0]}
					style={{ border: "unset", marginLeft: 7 }}
					name="home"
					fitted
					onClick={(e) => {
						if (!userAuth.isSubsriptionActive) {
							e.preventDefault();
						}
					}}
				>
					<Image src={logo} id="aFLogo" />
				</Menu.Item>

				<Menu.Item style={{ margin: "auto", padding: 0 }}>
					<PageTitle
						moduleNavigation={moduleNavigation}
						pageTitle={pageTitle}
						currentClientId={userAuth.currentClientId}
						relatedLinks={relatedLinks}
					/>
				</Menu.Item>

				{isAuthenticated &&
					renderAuthenticated(
						userAuth,
						userAuth.user.userInfo,
						clientLogoUri,
						clients,
						userAuth.currentClientId,
						userAuth.handleClientChange,
					)}
			</Menu>
		</header>
	);
};

const PageTitle = ({ moduleNavigation, pageTitle, currentClientId, relatedLinks }) => {
	const jumpIcons = {
		Protocol: "folder open",
		Field: "th large",
		Farm: "farm",
		Flight: "paper plane",
		Trial: "leaf",
	};

	const userSettings = useUserSettings();

	const isTrial = useMemo(() => {
		return moduleNavigation.activeModule.name === "trials";
	}, [moduleNavigation.activeModule]);

	const isProtocol = useMemo(() => {
		return moduleNavigation.activeModule.name === "protocols";
	}, [moduleNavigation.activeModule]);

	const hasRelatedLinks = useMemo(() => {
		return (
			relatedLinks &&
			(relatedLinks.others.length > 0 ||
				relatedLinks.flights.length > 0 ||
				relatedLinks.dataLayers.length > 0 ||
				relatedLinks.trials.length > 0)
		);
	}, [relatedLinks]);

	const [menuOpen, setMenuOpen] = useState(false);
	const [flightsOpen, setFlightsOpen] = useState(false);
	const [trialsOpen, setTrialsOpen] = useState(false);
	const [dataLayersOpen, setDataLayersOpen] = useState(false);

	const closeOnBlur = useCallback(() => {
		setMenuOpen(false);
	}, []);

	useEffect(() => {
		if (open) {
			setTimeout(() => {
				window.addEventListener("click", closeOnBlur);
			});
		} else {
			window.removeEventListener("click", closeOnBlur);
		}

		return () => {
			window.removeEventListener("click", closeOnBlur);
		};
	});

	return pageTitle ? (
		<>
			<div className="headerTitle">
				<span className="headerModuleTitle">
					{moduleNavigation.activeSubmodule.pageTitle}
					{" / "}
				</span>
				<span className="headerPageTitle">{pageTitle}</span>

				{(isTrial || isProtocol || hasRelatedLinks) && (
					<Dropdown
						style={{ color: "#FFFFFF", fontSize: "1rem" }}
						pointing
						open={menuOpen}
						onOpen={() => setMenuOpen((prev) => !prev)}
					>
						<Dropdown.Menu style={{ transform: "translate(-50%, 0)", left: 16.5, zIndex: 2000 }}>
							{isTrial && currentClientId && moduleNavigation.trialId && (
								<TrialFavoritingWidget
									style={{ display: "inline" }}
									clientId={currentClientId.toUpperCase()}
									trialId={moduleNavigation.trialId.toUpperCase()}
									userSettings={userSettings}
									refreshPage={true}
								/>
							)}
							{isProtocol && currentClientId && moduleNavigation.protocolId && (
								<ProtocolFavoritingWidget
									style={{ display: "inline" }}
									clientId={currentClientId.toUpperCase()}
									protocolId={moduleNavigation.protocolId.toUpperCase()}
									userSettings={userSettings}
								/>
							)}
							{hasRelatedLinks && (
								<>
									<Dropdown.Item disabled>
										<div className="relatedLinksHeader">Related Links</div>
									</Dropdown.Item>
									{relatedLinks.others.map((rl, i) => (
										<Dropdown.Item as={Link} to={rl.linkTo} target="_blank" key={i} className="relatedLink">
											<Icon.Group style={{ width: 27 }}>
												<Icon name={jumpIcons[rl.type]} />
												<Icon className="shortcut" name="share" corner="bottom right" />
											</Icon.Group>
											<span>
												<b style={{ color: "#000000" }}>{rl.type}</b> ({rl.name})
											</span>
										</Dropdown.Item>
									))}
									{relatedLinks.trials.length > 0 && (
										<Accordion>
											<Accordion.Title style={{ padding: 0 }} active={trialsOpen}>
												<Dropdown.Item
													as={"a"}
													onClick={() => setTrialsOpen((prev) => !prev)}
													key={"trials"}
													className="relatedLink nested"
													style={{ padding: ".78571429em 1.14285714em" }}
												>
													<Icon.Group style={{ width: 27 }}>
														<Icon name="leaf" />
														<Icon
															className="shortcut"
															name="share"
															corner="bottom right"
															style={{
																display: "inline-block",
																float: "none",
																margin: "0 .75em 0 0",
																rotate: "315deg",
																fontSize: "9px",
															}}
														/>
													</Icon.Group>
													<span style={{ flexGrow: 1, display: "flex", justifyContent: "space-between" }}>
														<b style={{ color: "#000000" }}>Trials</b>
														<Icon name="dropdown" style={{ rotate: "90deg" }} />
													</span>
												</Dropdown.Item>
											</Accordion.Title>
											<Accordion.Content active={trialsOpen} style={{ padding: "0.5em 0px" }}>
												<List className="relatedList">
													{relatedLinks.trials.sort().map((rl, i) => (
														<List.Item key={i} as={Link} to={rl.linkTo} target="_blank" className="relatedLink">
															<span>{rl.name}</span>
														</List.Item>
													))}
												</List>
											</Accordion.Content>
										</Accordion>
									)}
									{relatedLinks.flights.length > 0 && (
										<Accordion>
											<Accordion.Title style={{ padding: 0 }} active={flightsOpen}>
												<Dropdown.Item
													as={"a"}
													onClick={() => setFlightsOpen((prev) => !prev)}
													key={"flights"}
													className="relatedLink nested"
													style={{ padding: ".78571429em 1.14285714em" }}
												>
													<Icon.Group style={{ width: 27 }}>
														<Icon name="paper plane" />
														<Icon
															className="shortcut"
															name="share"
															corner="bottom right"
															style={{
																display: "inline-block",
																float: "none",
																margin: "0 .75em 0 0",
																rotate: "315deg",
																fontSize: "9px",
															}}
														/>
													</Icon.Group>
													<span style={{ flexGrow: 1, display: "flex", justifyContent: "space-between" }}>
														<b style={{ color: "#000000" }}>Flights</b>
														<Icon name="dropdown" style={{ rotate: "90deg" }} />
													</span>
												</Dropdown.Item>
											</Accordion.Title>
											<Accordion.Content active={flightsOpen} style={{ padding: "0.5em 0px" }}>
												<List className="relatedList">
													{relatedLinks.flights
														.sort(
															(a, b) =>
																moment(a.dateAndTime).diff(moment(b.dateAndTime)) || a.name.localeCompare(b.name),
														)
														.map((rl, i) => (
															<List.Item key={i} as={Link} to={rl.linkTo} target="_blank" className="relatedLink">
																<span>
																	<b style={{ color: "#000000" }}>{moment(rl.dateAndTime).format("ll")}</b> ({rl.name})
																</span>
															</List.Item>
														))}
												</List>
											</Accordion.Content>
										</Accordion>
									)}
									{relatedLinks.dataLayers.length > 0 && (
										<Accordion>
											<Accordion.Title style={{ padding: 0 }} active={dataLayersOpen}>
												<Dropdown.Item
													as={"a"}
													onClick={() => setDataLayersOpen((prev) => !prev)}
													key={"flights"}
													className="relatedLink nested"
													style={{ padding: ".78571429em 1.14285714em" }}
												>
													<Icon.Group style={{ width: 27 }}>
														<Icon name="data layers" />
														<Icon
															className="shortcut"
															name="share"
															corner="bottom right"
															style={{
																display: "inline-block",
																float: "none",
																margin: "0 .75em 0 0",
																rotate: "315deg",
																fontSize: "9px",
															}}
														/>
													</Icon.Group>
													<span style={{ flexGrow: 1, display: "flex", justifyContent: "space-between" }}>
														<b style={{ color: "#000000" }}>Data Layers</b>
														<Icon name="dropdown" style={{ rotate: "90deg" }} />
													</span>
												</Dropdown.Item>
											</Accordion.Title>
											<Accordion.Content active={dataLayersOpen} style={{ padding: "0.5em 0px" }}>
												<List className="relatedList">
													{relatedLinks.dataLayers
														.sort(
															(a, b) =>
																moment(a.dateAndTime).diff(moment(b.dateAndTime)) || a.name.localeCompare(b.name),
														)
														.map((rl, i) => (
															<List.Item key={i} as={Link} to={rl.linkTo} target="_blank" className="relatedLink">
																<span>
																	<b style={{ color: "#000000" }}>{rl.name}</b> ({moment(rl.dateAndTime).format("ll")})
																</span>
															</List.Item>
														))}
												</List>
											</Accordion.Content>
										</Accordion>
									)}
								</>
							)}
						</Dropdown.Menu>
					</Dropdown>
				)}
			</div>
		</>
	) : (
		<>
			<div className="headerTitle">
				<span className="headerPageTitle">{moduleNavigation.activeSubmodule.pageTitle}</span>
			</div>
		</>
	);
};

const renderAuthenticated = (userAuth, userInfo, clientLogoUri, clients, currentClientId, handleClientChange) => {
	const [clientList, setClientList] = useState([]);
	const [menuOpen, setMenuOpen] = useState(false);

	const closeOnBlur = useCallback(() => {
		setMenuOpen(false);
	}, []);

	useEffect(() => {
		if (open) {
			setTimeout(() => {
				window.addEventListener("click", closeOnBlur);
			});
		} else {
			window.removeEventListener("click", closeOnBlur);
		}

		return () => {
			window.removeEventListener("click", closeOnBlur);
		};
	});

	useEffect(() => {
		setClientList(clients);
	}, [clients]);

	const updateClientList = (query) => {
		const re = RegExp(_.escapeRegExp(query), "i");
		setClientList(_.filter(clients, (client) => re.test(client.text)));
	};

	return (
		<>
			<Menu.Menu id="userContextMenu">
				<span style={{ margin: "auto" }}>{`Hello, ${userInfo.basic.firstName}!`}</span>
				<Menu.Item name="userContext">
					<Dropdown
						style={{ color: "var(--nav-secondary)" }}
						open={menuOpen}
						onOpen={() => setMenuOpen((prev) => !prev)}
						trigger={
							<span>
								{clientLogoUri ? (
									<Image src={clientLogoUri} size="tiny" style={{ maxWidth: "80px", maxHeight: "60px" }} inline />
								) : (
									clients &&
									clients.length > 1 && (
										<span>
											(
											{
												clients.find((c) => {
													return c.value === currentClientId;
												}).text
											}
											)
										</span>
									)
								)}
							</span>
						}
					>
						<Dropdown.Menu
							style={{
								overflowY: "auto",
								maxHeight: "600px",
								minWidth: "300px",
								zIndex: "1100",
								right: 0,
								left: "unset",
							}}
						>
							<Dropdown.Header
								style={{ fontWeight: "unset", textTransform: "unset", opacity: ".75" }}
								content={
									<Tooltip
										placement="bottom"
										mouseEnterDelay={0}
										mouseLeaveDelay={0}
										trigger="hover"
										overlay={`${userInfo.basic.emailAddress}`}
										transitionName="rc-tooltip-zoom"
									>
										<span>
											Signed in as <strong>{`${userInfo.basic.firstName} ${userInfo.basic.lastName}`}</strong>
										</span>
									</Tooltip>
								}
							/>
							<Dropdown.Item>
								<Link to="/logout" style={{ display: "block" }}>
									<Icon name="sign out" size="small" />
									<span style={{ color: "#000000" }}>Log Out</span>
								</Link>
							</Dropdown.Item>
							<Dropdown.Divider />
							{(userAuth.isApAdmin ||
								userAuth.hasApplicationArea(ApplicationArea.ApSettings, userAuth.currentClientId) ||
								userAuth.hasApplicationArea(ApplicationArea.ClientSettings, userAuth.currentClientId)) && (
								<>
									<Dropdown.Item>
										<Link
											to={userAuth.isApAdmin ? "/ap-settings" : "/client-settings"}
											style={{ display: "block" }}
											target="_blank"
										>
											<Icon name="cog" size="small" />
											<span style={{ color: "#000000" }}>Settings</span>
										</Link>
									</Dropdown.Item>
									<Dropdown.Divider />
								</>
							)}
							<Dropdown.Item>
								<Link to="/support" style={{ display: "block" }}>
									<Icon name="help" size="small" />
									<span style={{ color: "#000000" }}>Support</span>
								</Link>
							</Dropdown.Item>
							<Dropdown.Divider />

							<Dropdown.Header
								style={{
									position: "sticky",
									top: 0,
									backgroundColor: "#ffffff",
									fontWeight: "unset",
									textTransform: "unset",
									color: "rgba(0,0,0,0.6375)",
									margin: 0,
									paddingTop: "1rem",
									paddingBottom: ".75rem",
									zIndex: 14,
								}}
							>
								{clientList && clientList.length === 1 ? `Organization` : `Organizations`}
							</Dropdown.Header>
							{clients && clients.length > 1 && (
								<Input
									style={{
										position: "sticky",
										top: 38.5,
										backgroundColor: "#ffffff",
										zIndex: 14,
										marginRight: 0,
									}}
									onClick={(e) => e.stopPropagation()}
									onKeyDown={(e) => {
										e.code === "Space" && e.stopPropagation();
									}}
									onChange={(e, { value }) => {
										updateClientList(value);
									}}
									icon="search"
									iconPosition="left"
								/>
							)}
							{_.map(clientList, ({ key, value, text }) => {
								return (
									<Dropdown.Item
										className="clientContainer"
										style={{}}
										key={key}
										id={value}
										onClick={(event, data) => {
											handleClientChange(data.id);
										}}
									>
										{value === currentClientId ? <Icon name="check circle outline" color="green" /> : null}
										{text}
									</Dropdown.Item>
								);
							})}
						</Dropdown.Menu>
					</Dropdown>
				</Menu.Item>
			</Menu.Menu>
		</>
	);
};

PageTitle.propTypes = {
	moduleNavigation: PropTypes.object,
	pageTitle: PropTypes.string,
	currentClientId: PropTypes.string,
	relatedLinks: PropTypes.object,
};

Header.propTypes = {
	entityNames: PropTypes.object,
	pageTitle: PropTypes.string,
};

export default Header;
